import { isEmpty } from 'lodash';

const checkIsResetAllFilter = ({ selectedTab, filterState }) => {
  let isResetVisible = false;

  switch (selectedTab) {
    case 'talkingPoint':
      const talkingPointFilter = filterState?.talkingPoint;

      isResetVisible = !isEmpty(talkingPointFilter?.statusDraft) || !isEmpty(talkingPointFilter?.status);

      break;

    case 'giveaway':
      const giveawayFilter = filterState?.giveaway;

      isResetVisible = !isEmpty(giveawayFilter?.statusDraft) || !isEmpty(giveawayFilter?.status) || !isEmpty(giveawayFilter?.promoSearch);

      break;

    default:
      break;
  }

  return isResetVisible;
};

export default checkIsResetAllFilter;
